// removed by extract-text-webpack-plugin
module.exports = {"modules":"src-display-components-RecentlyVisited-index__modules--1hHtx","btn":"src-display-components-RecentlyVisited-index__btn--3CR_k","menuItem":"src-display-components-RecentlyVisited-index__menuItem--3bWyr"};


//////////////////
// WEBPACK FOOTER
// ./src/display/components/RecentlyVisited/index.scss
// module id = 7092
// module chunks = 0